import React from 'react';
import { motion } from 'framer-motion';
export function Transition() {
  return <section className="py-24 md:py-32 bg-peach text-white text-center px-6 relative overflow-hidden" data-id="element-325">
      <div className="absolute top-10 left-10 grid grid-cols-5 gap-2 opacity-20" data-id="element-326">
        {[...Array(25)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-full bg-white" data-id="element-327"></div>)}
      </div>
      <div className="absolute bottom-10 right-10 grid grid-cols-5 gap-2 opacity-20" data-id="element-328">
        {[...Array(25)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-full bg-white" data-id="element-329"></div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto relative z-10" data-id="element-330">
        <h2 className="font-serif leading-[1.05] tracking-tight" style={{
        fontSize: 'clamp(2rem, 6vw, 5rem)'
      }} data-id="element-331">
          ¿Y si pudieras atravesar esta etapa con
          <span className="italic" data-id="element-332"> más calma, claridad y confianza</span>?
        </h2>
      </motion.div>
    </section>;
}